import { BasePinErrorDialog } from "./BasePinErrorDialog";

export function PinSessionEndedErrorDialog() {
  return BasePinErrorDialog(
    'Session Ended',
    'Your session is no longer active.  Please refresh the page to log in.'
  )
}
